const storeProjectId: string | null = localStorage.getItem('projectId');


export const initialValuesJobScope = {
    projectId: storeProjectId,
    jobScopeResults: [
        {
            projectId: storeProjectId,
            surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            name: "",
            surveyResultOriginal: "",
            fieldType: "",
            sectionId: 0,
            subSectionId: 0
        }
    ]
}
